import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('SetTrackingDataInput')
export class SetTrackingDataInput {
  @JsonProperty('trackingNumber', String, true) trackingNumber: string = undefined;
  @JsonProperty('trackingUrl', String, true) trackingUrl: string = undefined;
  @JsonProperty('carrier', String, true) carrier: string = undefined;
}
